import type { HeroSlideInput } from '@shop-monorepo/types';
import { Button, Form, Input, InputNumber, Switch } from 'antd';
import React from 'react';

import { FilePicker } from '@/components/FilePicker';

interface HeroSlideFormProps {
  initialValues?: Partial<HeroSlideInput>;
  onSubmit: (values: HeroSlideInput) => Promise<void>;
  isSubmitting: boolean;
}

export const HeroSlideForm: React.FC<HeroSlideFormProps> = ({
  initialValues,
  onSubmit,
  isSubmitting,
}) => {
  const [form] = Form.useForm();

  const handleFinish = async (values: HeroSlideInput) => {
    const payload: HeroSlideInput = {
      ...values,
      isActive: values.isActive ?? true,
    };

    await onSubmit(payload);
    form.resetFields();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={{ isActive: true, sortOrder: 0, ...initialValues }}
    >
      <Form.Item
        name="image"
        label="Зображення"
        rules={[{ required: true, message: 'Будь ласка, завантажте зображення' }]}
      >
        <FilePicker />
      </Form.Item>
      <Form.Item
        name="title"
        label="Заголовок"
        rules={[{ required: true, message: 'Будь ласка, введіть заголовок' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="text"
        label="Текст"
        rules={[{ required: true, message: 'Будь ласка, введіть текст' }]}
      >
        <Input.TextArea rows={3} />
      </Form.Item>
      <Form.Item
        name="btnText"
        label="Текст кнопки"
        rules={[{ required: true, message: 'Будь ласка, введіть текст кнопки' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="btnHref"
        label="Посилання кнопки"
        rules={[{ required: true, message: 'Будь ласка, введіть посилання' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="sortOrder"
        label="Порядок"
        rules={[{ required: true, message: 'Будь ласка, вкажіть порядок' }]}
      >
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="isActive" label="Активний" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={isSubmitting}>
          Зберегти
        </Button>
      </Form.Item>
    </Form>
  );
};
